/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';


// DEBUG
declare global {
    // Note the capital "W"
    interface Window { DEBUG: any; }
}
window.DEBUG = window.DEBUG || {};


/* Theme variables */
import '@/theme/theme.scss';

/* app without store */
import { createApp } from 'vue'
import KapitelApp from './App.vue'
const app = createApp(KapitelApp)

/* sentry */
import { useSentry } from './helper/sentry';
useSentry(app)

/* app with pinia store*/
import { createPinia } from 'pinia';
const pinia = createPinia()
/* pinia with persisted state */
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
pinia.use(piniaPluginPersistedState);
app.use(pinia)

/* ionic */
import {alertController, IonicVue} from '@ionic/vue';
app.use(IonicVue, {
    mode: 'ios',
    // experimentalCloseWatcher: true, // hw back button in PWA
    swipeBackEnabled: false
})

/* router */
import router from './router';
app.use(router)

/* auth subsystem */
// import {initAuth} from "@/helper/auth";
// initAuth();

/* Directives */
import { longpress } from '@/directives/longpress'
app.directive('longpress', longpress)


/* Capacitor App */
import {App as CapacitorApp, URLOpenListenerEvent} from '@capacitor/app';

/* // attach universal link listener: https://capacitorjs.com/docs/guides/deep-links#vue */
import {informAppStateAboutUniversalLink} from './helper/appState';
CapacitorApp.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    consoleLogApp('CapacitorApp appUrlOpen (App opened with URL), event:', event);
    informAppStateAboutUniversalLink(event.url);
});

/* hardware back button */
import { useBackButton } from '@ionic/vue';
import {useChatStore} from "@/helper/chat/chatStore";
import {reloadChat} from "@/helper/chat/chatBL";
const backButtonHandler = (processNextHandler: () => void) => {
    const currentRoute = router.currentRoute.value
    const chatStore = useChatStore()
    if(!(chatStore.nothingHappenedYet && !chatStore.scriptedMessage)){
        reloadChat()
        processNextHandler()
        return
    } else if (window.history.length === 0 || currentRoute.meta.exitOnHardwareBack ) {
        CapacitorApp.exitApp();
    }
}
useBackButton(-1, backButtonHandler);

/* app active state */
import useEmitter from "@/helper/emitter";
import {consoleLogApp} from "@/helper/console";
const emitter = useEmitter()
CapacitorApp.addListener('appStateChange', ({ isActive }) => {
    consoleLogApp('CapacitorApp appStateChange, active: ', isActive)
    if (isActive) {
        emitter.emit('CapacitorAppStateChange:active')
    }else{
        emitter.emit('CapacitorAppStateChange:inactive')
    }
})

/* Android Safe Area */
import { SafeArea } from '@capacitor-community/safe-area';
SafeArea.enable({
  config: {
    customColorsForSystemBars: true,
    statusBarColor: '#00000000', // transparent
    statusBarContent: 'dark',
    navigationBarColor: '#00000000', // transparent
    navigationBarContent: 'dark',
  },
});

/* apex charts */
import VueApexCharts from "vue3-apexcharts";
app.use(VueApexCharts);

import {env} from "@/helper/env";
if (!env.isProduction()) {
    document.title += ` [${env.getEnvironment()}]`
}

/* finally: hand over to appState helper */
import {useAppState} from './helper/appState';
const appState = useAppState()
appState.init()
    .finally(async () => await router.isReady())
    /* finally: mount app */
    .finally(() => app.mount('#app'))
